<!--生产加工 生产入库-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
          style="padding-top: 0; margin-top: 0">
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择" :clearable="true"
              @change="queryProject">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" @change="queryDk()" placeholder="请选择" clearable>
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
                <span style="float: left">{{ item.PROJECT_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：">
            <el-select size="medium" filterable v-model="searchForm.DK" placeholder="请选择档口" style="width: 100%" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库状态：">
            <el-select size="medium" filterable v-model="searchForm.produceWarehouseFlag" placeholder="请选择档口" style="width: 100%">
              <el-option v-for="item in flags" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item><br>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="queryData" :loading="initLoad">筛选</el-button>
            <el-button size="medium" id="search" @click="create">创建生产入库单</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="销售订单编号"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column width="65" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="openDetail(scope.row)">入库</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="visible" width="30%" center>
      <el-form :ref="dialogForm" :model="dialogForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="生产部门：">
          <el-select filterable v-model="dialogForm.department" style="width: 100%">
            <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button @click="gotoProReceiptDetail">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="visible2" width="30%" center>
      <el-form :ref="dialogForm2" :model="dialogForm2" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="生产部门：">
          <el-select filterable v-model="dialogForm2.department" style="width: 100%">
            <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible2 = false">取 消</el-button>
        <el-button @click="createProReceipt">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryDepartment } from 'api/productDepart';
import {
  haveDSXMDFun, selectDKFun, selectTCFun, allOrderDataFun,
} from 'api/sellOrder';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        TC_COMPANY: '',
        PROJECT: '',
        DK: '',
        DAY_INTERVAL: [],
        produceWarehouseFlag: 0,
      },
      departmentList: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      visible: false,
      dialogForm: {},
      visible2: false,
      dialogForm2: {},
      companys: [],
      points: [],
      dkList: [],
      initLoad: false,
      flags: [
        { NAME: '未生产入库', ID: 0 },
        { NAME: '已生产入库', ID: 1 },
      ],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (JSON.stringify(this.PRO_WAREHOUSING) != '{}' && this.PRO_WAREHOUSING != undefined) {
      this.searchForm = this.PRO_WAREHOUSING.CONDITION;
      this.currentPage = this.PRO_WAREHOUSING.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryCustomer();
    this.queryData();
    this.queryDepartment();
  },
  computed: {
    PRO_WAREHOUSING() {
      return this.$store.state.SAVE_PRO_WAREHOUSING;
    },
  },
  methods: {
    // 获取部门
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取订单列表
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        PRODUCE_WAREHOUSE_FLAG: this.searchForm.produceWarehouseFlag,
      };
      if (this.searchForm.TC_COMPANY != '') {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT != '') {
        params.PROJECTS_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (this.searchForm.DK != '') {
        params.DK_ID = this.searchForm.DK;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL.length != 0) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      allOrderDataFun(params).then((res) => {
        if (res[0]) {
          this.tableData = res[0].list;
          this.totalCount = res[0].TOTAL_COUNT;
          // 将搜索结果和条件存储到vuex中
          this.$store.dispatch('SET_SAVE_PRO_WAREHOUSING', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 入库
    openDetail(row) {
      sessionStorage.setItem('titleData', JSON.stringify(row));
      this.visible = true;
    },
    // 换页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // 下拉框获取档口名称
    queryDk() {
      this.searchForm.DK = '';
      if (this.searchForm.PROJECT.length === 0) {
        // 当项目点选框为空时，不获取档口名称
        this.dkList = [];
        return false;
      }
      const params = {};
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      } else {
        this.dkList = [];
        return false;
      }
      selectDKFun(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 选择客户
    queryCustomer() {
      selectTCFun()
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].company;
          } else {
            this.companys = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取项目点信息列表
    queryProject() {
      this.searchForm.PROJECT = '';
      this.searchForm.DK = '';
      if (this.searchForm.TC_COMPANY) {
        const params = {
          TC_ID: this.searchForm.TC_COMPANY,
        };
        haveDSXMDFun(params)
          .then((result) => {
            this.points = result.length > 0 ? result[0].project : [];
          })
          .catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }
    },
    gotoProReceiptDetail() {
      if (this.dialogForm.department) {
        this.$router.push({ path: `/proWarehousingDetails/${this.dialogForm.department}`, params: { department: this.dialogForm.department } });
        sessionStorage.setItem('orderStatus', this.searchForm.ORDER_STATUS);
      } else {
        this.$message.show({ text: '请选择领料部门', type: 'warning' });
      }
    },
    // 创建生产入库单
    create() {
      this.visible2 = true;
    },
    createProReceipt() {
      if (this.dialogForm2.department) {
        this.$router.push({ path: `/proManualWarehousing/${this.dialogForm2.department}`, params: { department: this.dialogForm2.department } });
      } else {
        this.$message.show({ text: '请选择领料部门', type: 'warning' });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/proWarehousing.vue